// The status shown in the App header next to the tabs ("● live · plan 4 min ago"): a pill on phones, two
// right-aligned lines on tablets, one row on the web. The first line carries the dot (red when stale).
import * as React from 'react';

import { LayoutSize } from '../../util';
import { Dot } from './card';
import { ALERT, CARD_BG, DOT, HAIRLINE_STRONG, SECONDARY } from './tokens';

export interface HeaderStatusText {
  phone: string;
  tablet: [string, string?];
  web: [string, ...React.ReactNode[]];
}

export function HeaderStatus(props: { size: LayoutSize; stale: boolean; text: HeaderStatusText }): React.ReactElement {
  const { size, stale, text } = props;
  const dot = <Dot color={stale ? DOT.critical : DOT.good} size={7} />;
  const lead = (s: string) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: stale ? ALERT.fg : undefined }}>
      {dot}
      {s}
    </span>
  );
  if (size === 'phone') {
    return (
      <span
        className="num"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          fontSize: 12,
          color: stale ? ALERT.fg : SECONDARY,
          background: CARD_BG,
          border: `1px solid ${HAIRLINE_STRONG}`,
          borderRadius: 999,
          padding: '5px 10px',
          whiteSpace: 'nowrap',
        }}
      >
        {dot}
        {text.phone}
      </span>
    );
  }
  if (size === 'tablet') {
    return (
      <div
        className="num"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 2,
          fontSize: 12,
          color: SECONDARY,
        }}
      >
        {lead(text.tablet[0])}
        {text.tablet[1] && <span>{text.tablet[1]}</span>}
      </div>
    );
  }
  const [first, ...rest] = text.web;
  return (
    <div className="num" style={{ display: 'flex', alignItems: 'center', gap: 14, fontSize: 12, color: SECONDARY }}>
      {lead(first)}
      {rest.map((r, i) => (
        <React.Fragment key={i}>{typeof r === 'string' ? <span>{r}</span> : r}</React.Fragment>
      ))}
    </div>
  );
}
